import Cookies from "js-cookie";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import SubCategoryCard from "./SubCategoryCard";
import LoadingSpinner from "../Utilities/LoadingSpinner";

const SubCategoryContainer = ({ category, loading, parentCategory }) => {
  const { t } = useTranslation();
  
  // Depending on how getOneCategory wraps its response, it might be parentCategory.data or parentCategory.data.data
  let actualParent = parentCategory?.data?.data || parentCategory?.data || parentCategory;
  if (Array.isArray(actualParent)) {
    actualParent = actualParent[0] || {};
  }
  
  const parentName = actualParent ? (Cookies.get("i18next") === 'ar' ? (actualParent.nameAr || actualParent.name || "") : (actualParent.nameEn || actualParent.name || "")) : "";

  return (
    <Container className="py-5">
      <div className="d-flex align-items-center mb-5" style={{ gap: '20px' }}>
        {actualParent?.image && (
          <div className="premium-brand-logo">
            <img
              src={actualParent.image}
              alt={parentName}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        )}
        <div>
          <h1 className="premium-page-title">{parentName || t("All SubCategories")}</h1>
          <p className="premium-page-subtitle text-muted mb-0">
            {Cookies.get("i18next") === 'ar' ? "تصفح أحدث التصنيفات الفرعية" : "Browse the latest subcategories"}
          </p>
        </div>
      </div>

      <div className="d-flex flex-wrap justify-content-center" style={{ gap: '20px' }}>
        {loading === false ? (
          category && category.length > 0 ? (
            category.map((el) => {
              return (
                <SubCategoryCard
                  key={el._id}
                  title={Cookies.get("i18next") === 'ar' ? el.nameAr : el.nameEn}
                  img={el.image}
                  id={el._id}
                />
              );
            })
          ) : (
            <h5 className="text-center w-100 mt-4 text-muted">{t("no categories")}</h5>
          )
        ) : (
          <div className="w-100 d-flex justify-content-center">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </Container>
  );
};

export default SubCategoryContainer;
